import React, { useState } from "react";
import "./Contact.css";
import contactImage from "../Assets/contact-us2.webp";

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        itemCode: "",
        phone: "",
        message: ""
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Format the message for WhatsApp
        const whatsappMessage = `
*New Inquiry from Website* 📝

*Name:* ${formData.name}
*Item Code:* ${formData.itemCode}
*Phone:* ${formData.phone}

*Message:*
${formData.message}
        `.trim();

        // Encode the message for URL
        const encodedMessage = encodeURIComponent(whatsappMessage);
        
        // Open WhatsApp with pre-filled message
        window.open(`https://wa.me/94710881919?text=${encodedMessage}`, "_blank", "noopener,noreferrer");
        
        // Reset form after submission
        setFormData({
            name: "",
            itemCode: "",
            phone: "",
            message: ""
        });
    };

    return (
        <div className="contact-page">
            {/* Header Section */}
            <section className="contact-hero">
                <img src={contactImage} alt="Contact Us" className="contact-hero-img" />
                <div className="contact-hero-overlay">
                    <div className="contact-hero-card">
                        <h1>Contact Us</h1>
                    </div>
                </div>
            </section>

            {/* Cards Section */}
            <div className="contact-content">
                {/* Left Card */}
                <div className="contact-info-card">
                    <h2>Contact Info</h2>
                    <p className="contact-description">
                        We're here to assist you with all your jewellery inquiries. Whether you're looking for 
                        information about a specific piece from our collection, need help with custom designs, 
                        or have questions about our services, our dedicated team is ready to help. Reach out to 
                        us for product details, pricing information, special requests, or any assistance you need. 
                        We pride ourselves on providing excellent customer service and ensuring your jewellery 
                        shopping experience is exceptional. Feel free to contact us through any of the channels 
                        below, and we'll respond promptly to your inquiries.
                    </p>

                    <div className="info-section">
                        <h3>Address</h3>
                        <p>No:154/1, Kandy Road, Kadawatha.</p>

                        <h3>Tel:</h3>
                        <p>+94 71 088 1919</p>

                        <h3>Email</h3>
                        <p>dewalegama.jewellers@gmail.com</p>
                    </div>
                </div>

                {/* Right Card - Inquiry Form */}
                <div className="inquiry-form-card">
                    <h2>Get Free Inquiry Now</h2>
                    <p>Send us a message via WhatsApp</p>

                    <form className="inquiry-form" onSubmit={handleSubmit}>
                        <input 
                            type="text" 
                            name="name"
                            placeholder="Name" 
                            value={formData.name}
                            onChange={handleInputChange}
                            required 
                        />
                        <input 
                            type="text" 
                            name="itemCode"
                            placeholder="Item Code (e.g., G01, SS02)" 
                            value={formData.itemCode}
                            onChange={handleInputChange}
                            required 
                        />
                        <input 
                            type="tel" 
                            name="phone"
                            placeholder="Telephone Number" 
                            value={formData.phone}
                            onChange={handleInputChange}
                            required 
                        />
                        <textarea 
                            name="message"
                            placeholder="Message" 
                            value={formData.message}
                            onChange={handleInputChange}
                            required
                        ></textarea>
                        
                        <p className="form-note">
                            📱 Click "Send Message" to open WhatsApp with your inquiry pre-filled.
                            We will reply as soon as possible!
                        </p>

                        <button type="submit" className="send-btn">
                            Send via WhatsApp
                        </button>
                    </form>
                </div>
            </div>

            {/* Google Map Section */}
            <div className="map-section">
                <h2 className="map-title">📍 Find Us</h2>
                <iframe
                    title="Dewalegama Jewellers Map"
                    src="https://www.google.com/maps?q=Dewalegama%20Jewellers%2C%20No%3A154%2F1%2C%20Kandy%20Road%2C%20Kadawatha&output=embed"
                    allowFullScreen
                    loading="lazy"
                    className="google-map"
                ></iframe>
            </div>
        </div>
    );
};

export default Contact;